import styled from 'styled-components';
import { Buttons } from '@taxdown/piccolo-web';
import { DESKTOP_EXTRA_SMALL_WIDTH } from 'Styles/variables/sizes';

export const IconContainer = styled.div`
  display: none;
  @media screen and (max-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    display: flex;
    cursor: pointer;
    justify-content: flex-end;
    margin-left: 10px;
    height: 30px;
    right: 20px;
  }
`;

export const HelpButton = styled(Buttons.Contextual)`
  margin-left: ${({ theme: { reference } }) => reference.dimension_08};
  display: inline-block;
  vertical-align: middle;
`;
